import { UserDto } from './user.model';
import { Profile } from './profile';

export class CurrentUser extends UserDto {
  /**
   *
   */
  constructor() {
    super();    
  }
}
  